import React, { Fragment, useEffect, useState, useMemo } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import {
  obtenerInstituciones,
  sedesPorInstitucionId,
} from "../../Services/Rest";
import InformacionGrupoAyB from "./DataTable";
import Swal from "sweetalert2";
import IndicadorAyBManual from "../../Manual/IndicadorAyBManual";

function GrupoAyB() {
  const [isLoading, setLoading] = useState(false);
  const cookies = new Cookies();

  const [archivos, setArchivos] = useState(null);
  const [listINS, setListINS] = useState([]);
  const [list, setList] = useState([]);
  const [sedeSeleccionada, setSedeSeleccionada] = useState("");
  const [institucionSeleccionada, setInstitucionSeleccionada] = useState("");
  const [postGrupo, setPostGrupo] = useState("");

  const tipoUsuario = Number(cookies.get("tipo_Usuario"));

  const puedeSeleccionarInstitucion = useMemo(
    () => [1, 4, 6].includes(tipoUsuario),
    [tipoUsuario],
  );

  const institucionId = useMemo(() => {
    return puedeSeleccionarInstitucion
      ? institucionSeleccionada
      : cookies.get("institucionid");
  }, [puedeSeleccionarInstitucion, institucionSeleccionada]);

  // 🔹 Obtener instituciones
  useEffect(() => {
    if (!puedeSeleccionarInstitucion) return;

    axios
      .get(obtenerInstituciones, {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      })
      .then((res) => setListINS(res.data))
      .catch(console.error);
  }, [puedeSeleccionarInstitucion]);

  // 🔹 Obtener sedes
  useEffect(() => {
    if (!institucionId) return;

    axios
      .get(sedesPorInstitucionId + institucionId, {
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
      })
      .then((res) => setList(res.data))
      .catch(console.error);
  }, [institucionId]);

  const subirArchivos = (e) => setArchivos(e);

  const insertarArchivos = async () => {
    if (puedeSeleccionarInstitucion && !institucionSeleccionada) {
      Swal.fire("Seleccione una institución", "", "warning");
      return;
    }

    if (!archivos || !sedeSeleccionada || !postGrupo) {
      Swal.fire("Seleccione sede, grupo y archivo", "", "warning");
      return;
    }

    const formData = new FormData();
    for (let i = 0; i < archivos.length; i++) {
      formData.append("files", archivos[i]);
    }

    setLoading(true);

    try {
      const basicAuth = btoa("BasicAuth@icontec.org:yQLzqmR7eZSuAmQZUqhY");

      const response = await axios.post(
        `https://suadesarrollo.azurewebsites.net/api/CargaMasivosIndicadorAyB?Grupo=${postGrupo}&InstitucionId=${institucionId}&IdSede=${sedeSeleccionada}`,
        formData,
        {
          headers: { Authorization: `Basic ${basicAuth}` },
        },
      );

      Swal.fire("Éxito", response.data, "success").then(() =>
        window.location.reload(),
      );
    } catch (error) {
      Swal.fire("Error", error.message, "error");
      setLoading(false);
    }
  };

  return (
    <Fragment>
      <div className="container">
        <div className="card shadow mb-4">
          <div className="card-header">
            <h6 className="text-primary">Indicadores Grupo A y B</h6>
          </div>

          <div className="card-body">
            {[1, 2, 4, 6].includes(tipoUsuario) && (
              <>
                {/* 🔹 Select Institución */}
                {puedeSeleccionarInstitucion && (
                  <select
                    className="form-control mb-3"
                    value={institucionSeleccionada}
                    onChange={(e) => setInstitucionSeleccionada(e.target.value)}
                  >
                    <option value="">Seleccione la institución</option>
                    {listINS.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.razon_Social}
                      </option>
                    ))}
                  </select>
                )}
                {cookies.get("tipo_Usuario") == 1 ||
                cookies.get("tipo_Usuario") == 2 ? (
                  <div>
                    {/* 🔹 Select Sede */}
                    <select
                      className="form-control mb-3"
                      value={sedeSeleccionada}
                      onChange={(e) => setSedeSeleccionada(e.target.value)}
                    >
                      <option value="">Seleccione la sede</option>
                      {list.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.nombre}
                        </option>
                      ))}
                    </select>

                    {/* 🔹 Select Grupo */}
                    <select
                      className="form-control mb-3"
                      value={postGrupo}
                      onChange={(e) => setPostGrupo(e.target.value)}
                    >
                      <option value="">Seleccione grupo</option>
                      <option value="A1">
                        {" "}
                        A1. Distribución de la población atendida
                      </option>
                      <option value="A2">
                        A2. Información de estructura, producción y eficiencia
                      </option>
                      <option value="A3">
                        {" "}
                        A3. Información sedes integradas en red
                      </option>
                      <option value="A4">
                        {" "}
                        A4. Infección asociada a la atención en salud
                      </option>
                      <option value="A5">
                        {" "}
                        A5. Guías de prácticas clínicas
                      </option>
                      <option value="A6">A6. Historia clínica</option>
                      <option value="A7">A7. Oportunidad en la atención</option>
                      <option value="A8">A8. Quejas</option>
                      <option value="A9">A9. Talento humano</option>
                      <option value="A10">A10. Información financiera</option>
                      <option value="B1">
                        B1. Indicadores de seguimiento a riesgos
                      </option>
                      <option value="B2">
                        B2. Indicadores resolución 256 de 2016
                      </option>
                      <option value="B3">
                        B3. Eventos trazadores de la calidad
                      </option>
                    </select>

                    {/* 🔹 Archivo */}
                    <input
                      type="file"
                      multiple
                      onChange={(e) => subirArchivos(e.target.files)}
                      className="form-control mb-3"
                    />

                    <button
                      className="btn btn-primary"
                      onClick={insertarArchivos}
                      disabled={isLoading}
                    >
                      {isLoading ? "Cargando..." : "Guardar"}
                    </button>
                  </div>
                ) : (
                  <h></h>
                )}
              </>
            )}

            <hr />

            {/* 🔹 VALIDACIÓN CLAVE */}
            {!institucionId && (
              <p style={{ fontWeight: "bold" }}>
                ⚠️ Seleccione una institución
              </p>
            )}

            {/* 🔹 SOLO SE RENDERIZA SI HAY INSTITUCIÓN */}
            {institucionId && (
              <InformacionGrupoAyB institucion={institucionId} />
            )}
          </div>
        </div>

        <IndicadorAyBManual />
      </div>
    </Fragment>
  );
}

export default GrupoAyB;
